import { AssetDTO } from "src/app/shared/models/models";

export class goals{
  goal:string = '';
}
export class AboutBannarDetails {
  pageTitle:string = '';
  aboutTitle:string = '';
  aboutSectionIcon: AssetDTO= new AssetDTO();
  aboutText:string = '';
  coverImage: AssetDTO= new AssetDTO();
  missionVisionSectionTitle:string = '';
  missionVisionSectionIcon: AssetDTO= new AssetDTO();
  missionTitle:string = '';
  mission:string = '';
  visionTitle:string = '';
  vision:string = '';
  goalsSectionTitle:string = '';
  goalsSectionIcon: AssetDTO= new AssetDTO();
  goals: goals = new goals;
  teamMembersSectionTitle:string = '';
  teamMembersSectionIcon: AssetDTO= new AssetDTO();
  teamMembers: AssetDTO= new AssetDTO();
  annualReportSectionTitle:string = '';
  annualReportSectionIcon: AssetDTO= new AssetDTO();
    hideAboutSection:string = '';
  hideMissionVisionSection:string = '';
  hideGoalsSection:string = '';
  hideTeamMembersSection:string = '';
  hideAnnualReportSection:string = '';
}

export class AboutBannarModel {
  flatData: AboutBannarDetails = new AboutBannarDetails();
}